import React from "react";
import Slider from "@mui/material/Slider";

import { Input } from "../../ui";
import { DEFAULT_SENDER_DAILY_QUOTA_MAX } from "./SenderLimitsSidebar";

type SenderLimitControlProps = {
  label: string;
  value: number;
  max?: number;
  readOnly?: boolean;
  onChange: (value: number) => void;
};

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

export default function SenderLimitControl({
  label,
  value,
  max = DEFAULT_SENDER_DAILY_QUOTA_MAX,
  readOnly = false,
  onChange,
}: SenderLimitControlProps) {
  return (
    <div className="space-y-0">
      <label className="block text-sm font-medium text-dark-black">{label}</label>
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <Slider
            value={value}
            min={0}
            max={max}
            disabled={readOnly}
            onChange={(_event, nextValue) => {
              const resolved = Array.isArray(nextValue) ? nextValue[0] : nextValue;
              onChange(clamp(Number(resolved || 0), 0, max));
            }}
            aria-label={label}
            sx={{
              color: "var(--color-brand-blue)",
              height: 6,
              "& .MuiSlider-track": { border: 0 },
              "& .MuiSlider-rail": { opacity: 0.3 },
              "& .MuiSlider-thumb": {
                width: 18,
                height: 18,
                backgroundColor: "var(--color-brand-orange)",
                border: "2px solid white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
              },
            }}
          />
        </div>
        <Input
          value={String(value)}
          disabled={readOnly}
          readOnly={readOnly}
          onChange={(event) => {
            const parsed = Number(event.target.value.replace(/[^\d]/g, ""));
            onChange(clamp(Number.isNaN(parsed) ? 0 : parsed, 0, max));
          }}
          inputMode="numeric"
          size="sm"
          containerClassName="w-[96px]"
          className="text-md"
        />
      </div>
    </div>
  );
}
